import React from "react"
import Dropdown from "../../../components/Dropdown"
import { TAstatistics } from "../../../services/statisticsAPI"
import { useDispatch } from "react-redux"
import { useEffect, useState } from "react"
import { setPageTitle } from "../../../redux/store/themeConfigSlice"
import { TAgetPopularHashtagSearchPost, TAgetTeamfluencerData } from "../../../services/instaAPI"
import HashtagSearchPostProfile from "../../../components/HashtagSearchPostProfile"
import { PostData } from "../../../types/hashtagSearchPostDatas"
import PostPicture from "../../../components/HashtagSearchPostPicture"
import TeamfluencerInstaData from "../../../components/TeamfluencerInstaProfile"
import StatisticCard from "./components/StatisticCard"
import { useNavigate } from "react-router-dom"
import { getErrorStatus, getErrorResponse } from "../../../types/error"

const Dashboard = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [totalBrands, setTotalBrands] = useState<number>(0)
  const [activeBrands30, setActiveBrands30] = useState<number>(0)
  const [activeBrands15, setActiveBrands15] = useState<number>(0)
  const [activeBrands7, setActiveBrands7] = useState<number>(0)
  const [paidBrands, setPaidBrands] = useState<number>(0)
  const [inTurkeys, setInTurkeys] = useState<number>(0)
  const [outOfTurkeys, setOutOfTurkeys] = useState<number>(0)
  const [totalCampaigns, setTotalCampaigns] = useState<number>(0)
  const [activeCampaigns, setActiveCampaigns] = useState<number>(0)
  const [totalUsers, setTotalUsers] = useState<number>(0)
  const [waitingApprovalUsers, setWaitingApprovalUsers] = useState<number>(0)
  const [approvedUsers, setApprovedUsers] = useState<number>(0)
  const [deletedUsers, setDeletedUsers] = useState<number>(0)
  const [totalCooperations, setTotalCooperations] = useState<number>(0)
  const [buttonClicked, setButtonClicked] = useState<boolean>(false)
  const [buttonClicked2, setButtonClicked2] = useState<number>(0)
  const [error, setError] = useState<string | null>(null)
  const [postData, setPostData] = useState<PostData | null>(null)
  const [teamfuencerData, setTeamfuencerData] = useState<PostData | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    dispatch(setPageTitle("Dashboard"))
  })

  useEffect(() => {
    setLoading(true)
    setError(null)
    const loadStatistics = async () => {
      try {
        const statistics_response = await TAstatistics()

        if (statistics_response) {
          setTotalBrands(statistics_response.totalBrands)
          setActiveBrands30(statistics_response.activeBrands30)
          setActiveBrands15(statistics_response.activeBrands15)
          setActiveBrands7(statistics_response.activeBrands7)
          setPaidBrands(statistics_response.paidBrands)
          setInTurkeys(statistics_response.inTurkey)
          setOutOfTurkeys(statistics_response.outOfTurkey)
          setTotalCampaigns(statistics_response.totalCampaigns)
          setActiveCampaigns(statistics_response.activeCampaigns)
          setTotalUsers(statistics_response.totalUsers)
          setWaitingApprovalUsers(statistics_response.waitingApprovalUsers)
          setApprovedUsers(statistics_response.approvedUsers)
          setDeletedUsers(statistics_response.deletedUsers)
          setTotalCooperations(statistics_response.totalCooperations)
          setLoading(false)
        } else {
          setError("No Data Found")
          setLoading(false)
        }
        const hashtag_search_response = await TAgetPopularHashtagSearchPost()
        setPostData(hashtag_search_response[0])
      } catch (error: unknown) {
        if (getErrorStatus(error) === 401) {
          navigate("/login")
        }
        setError(`Error Fetching Data!, ${getErrorResponse(error) || "Unknown error"}`)
        setLoading(false)
      }
    }
    loadStatistics()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const testTeamfuencer = async () => {
    try {
      const data = await TAgetTeamfluencerData()
      if (!data) {
        throw new Error("No data found")
      }
      setTeamfuencerData(data)
    } catch (error: unknown) {
      if (getErrorStatus(error) === 401) {
        navigate("/login")
      }
      setError(`Error Fetching Data! ${getErrorResponse(error) || "Unknown error"}`)
    }
  }

  return (
    <div>
      <ul className="flex space-x-2 rtl:space-x-reverse">
        <li className="font-extrabold">Kontrol Paneli</li>
        <li className="before:content-['/'] ltr:before:mr-2 rtl:before:ml-2">
          <span>İstatistikler</span>
        </li>
      </ul>
      <div className="pt-5">
        {error && <div className="text-red-500">{error}</div>}
        {loading ? (
          <div className="flex items-center justify-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-pink-600"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6 mb-6 text-white">
            <StatisticCard title="Toplam Markalar" value={totalBrands} />
            <StatisticCard title="Ödeme Yapan Markalar" value={paidBrands} />

            {/*  Brands in TR / out of TR  */}
            <div className="flex flex-col panel bg-indigo-100">
              <div className="flex justify-between">
                {buttonClicked === false ? (
                  <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold text-indigo-600">
                    {"Türkiye'deki Markalar"}
                  </div>
                ) : (
                  <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold text-indigo-600">
                    Yurtdışındaki Markalar
                  </div>
                )}
                <div className="dropdown">
                  <Dropdown
                    offset={[0, 5]}
                    btnClassName="hover:opacity-80"
                    button={
                      <svg
                        className="w-5 h-5 opacity-70"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="5" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" />
                        <circle
                          opacity="0.5"
                          cx="12"
                          cy="12"
                          r="2"
                          stroke="currentColor"
                          strokeWidth="1.5"
                        />
                        <circle cx="19" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" />
                      </svg>
                    }
                  >
                    <ul className="text-black dark:text-white-dark">
                      <li>
                        <button type="button" onClick={() => setButtonClicked(false)}>
                          {"Türkiye'dekiler"}
                        </button>
                      </li>
                      <li>
                        <button type="button" onClick={() => setButtonClicked(true)}>
                          {"Yurtdışındakiler"}
                        </button>
                      </li>
                    </ul>
                  </Dropdown>
                </div>
              </div>
              {buttonClicked === false ? (
                <div className="flex justify-center mt-7">
                  <div className="text-3xl font-bold ltr:mr-3 rtl:ml-3 text-indigo-600">
                    {inTurkeys}
                  </div>
                </div>
              ) : (
                <div className="flex justify-center mt-7">
                  <div className="text-3xl font-bold ltr:mr-3 rtl:ml-3 text-indigo-600">
                    {outOfTurkeys}
                  </div>
                </div>
              )}
            </div>

            {/* Active Brands */}
            <div className="flex flex-col panel bg-indigo-100">
              <div className="flex justify-between text-indigo-600">
                {buttonClicked2 === 0 ? (
                  <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold">
                    Son 30 gündeki aktif markalar
                  </div>
                ) : buttonClicked2 === 1 ? (
                  <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold">
                    Son 15 gündeki aktif markalar
                  </div>
                ) : (
                  <div className="ltr:mr-1 rtl:ml-1 text-md font-semibold">
                    Son 7 gündeki aktif markalar
                  </div>
                )}
                <div className="dropdown">
                  <Dropdown
                    offset={[0, 5]}
                    btnClassName="hover:opacity-80"
                    button={
                      <svg
                        className="w-5 h-5 opacity-70"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="5" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" />
                        <circle
                          opacity="0.5"
                          cx="12"
                          cy="12"
                          r="2"
                          stroke="currentColor"
                          strokeWidth="1.5"
                        />
                        <circle cx="19" cy="12" r="2" stroke="currentColor" strokeWidth="1.5" />
                      </svg>
                    }
                  >
                    <ul className="text-black dark:text-white-dark">
                      <li>
                        <button type="button" onClick={() => setButtonClicked2(0)}>
                          Son 30 gün
                        </button>
                      </li>
                      <li>
                        <button type="button" onClick={() => setButtonClicked2(1)}>
                          Son 15 gün
                        </button>
                      </li>
                      <li>
                        <button type="button" onClick={() => setButtonClicked2(2)}>
                          Son 7 gün
                        </button>
                      </li>
                    </ul>
                  </Dropdown>
                </div>
              </div>
              {buttonClicked2 === 0 ? (
                <div className="flex justify-center mt-7">
                  <div className="text-3xl font-bold ltr:mr-3 rtl:ml-3 text-indigo-600">
                    {activeBrands30}
                  </div>
                </div>
              ) : buttonClicked2 === 1 ? (
                <div className="flex justify-center mt-7">
                  <div className="text-3xl font-bold ltr:mr-3 rtl:ml-3 text-indigo-600">
                    {activeBrands15}
                  </div>
                </div>
              ) : (
                <div className="flex justify-center mt-7">
                  <div className="text-3xl font-bold ltr:mr-3 rtl:ml-3 text-indigo-600">
                    {activeBrands7}
                  </div>
                </div>
              )}
            </div>

            <StatisticCard title="Toplam Kampanyalar" value={totalCampaigns} />
            <StatisticCard title="Aktif Kampanyalar" value={activeCampaigns} />
            <StatisticCard title=" Toplam İşbirlikleri (tamamlanan)" value={totalCooperations} />
            <StatisticCard title="Toplam Kullanıcılar" value={totalUsers} />
            <StatisticCard title="Onaylanan Kullanıcılar" value={approvedUsers} />
            <StatisticCard title="Onay Bekleyen Kullanıcılar" value={waitingApprovalUsers} />
            <StatisticCard title="Silinen Kullanıcılar" value={deletedUsers} />
          </div>
        )}
        <div className="pt-5">
          <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-6 mb-6">
            {/*  Teamfluencer Data  */}{" "}
            <div className="panel h-full sm:col-span-2 xl:col-span-1 mb-2">
              <div className="flex justify-between mb-3">
                <h5 className="font-semibold text-lg dark:text-white-light mb-5">
                  Teamfluencer Verileri
                </h5>
                <button className="btn" onClick={testTeamfuencer}>
                  Yenile
                </button>
              </div>
              <div className="w-full">
                {teamfuencerData && <TeamfluencerInstaData {...teamfuencerData} />}
              </div>
            </div>
            {/*  Popular Post  */}
            <div className="panel h-full sm:col-span-2 xl:col-span-1 mb-2">
              <h5 className="font-semibold text-lg dark:text-white-light mb-5">Popüler Post</h5>
              <div className="flex flex-row items-center mr-16">
                <PostPicture postData={postData} />
              </div>
              <div className="w-full">{postData && <HashtagSearchPostProfile {...postData} />}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Dashboard
